import { render } from "./VendorListItem.vue?vue&type=template&id=23111394&scoped=true"
import script from "./VendorListItem.vue?vue&type=script&lang=js"
export * from "./VendorListItem.vue?vue&type=script&lang=js"

import "./VendorListItem.vue?vue&type=style&index=0&id=23111394&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23111394"]])

export default __exports__